<template>
  <a href="https://www.instagram.com/tourherotravel/" target="_blank" rel="noreferrer noopener">
    <InstagramIcon />
  </a>
  <a href="https://www.facebook.com/tourherotravel/" target="_blank" rel="noreferrer noopener">
    <FacebookIcon />
  </a>
  <a href="https://www.linkedin.com/company/tourherotravel/" target="_blank" rel="noreferrer noopener">
    <LinkedinIcon />
  </a>
  <a href="https://www.youtube.com/channel/UCSQ3Vx9MZ1Q7OQDvnNmY_YQ" target="_blank" rel="noreferrer noopener">
    <YoutubeIcon />
  </a>
</template>

<script setup>
import InstagramIcon from 'app/assets/images/footer/instagram.svg?component'
import FacebookIcon from 'app/assets/images/footer/facebook.svg?component'
import LinkedinIcon from 'app/assets/images/footer/linkedin.svg?component'
import YoutubeIcon from 'app/assets/images/footer/youtube.svg?component'
</script>
